import React from 'react';
import {
  Badge,
  Box,
  Button,
  HStack,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';

function formatPrice(price) {
  if (price == null || !Number.isFinite(Number(price))) return null;
  return `€${Number(price).toLocaleString('en-EU', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

function formatDate(dateStr) {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  } catch {
    return null;
  }
}

function QuoteCard({ quote, listingId, onAccept }) {
  const price = formatPrice(quote.grossPrice ?? quote.netPrice);
  const pickup = formatDate(quote.proposedPickupDate);

  return (
    <Box borderWidth="1px" borderRadius="xl" p={3} bg="white" borderColor="gray.200">
      <Stack spacing={2}>
        <HStack justify="space-between" align="flex-start">
          <Stack spacing={0} flex={1}>
            <Text fontSize="sm" fontWeight="700" color="navy.700" noOfLines={1}>
              {quote.partnerName || quote.companyName || 'Partner'}
            </Text>
            {pickup ? (
              <Text fontSize="xs" color="gray.500">Pickup: {pickup}</Text>
            ) : null}
          </Stack>
          {price ? (
            <Text fontSize="sm" fontWeight="800" color="blue.600" flexShrink={0}>{price}</Text>
          ) : null}
        </HStack>

        {quote.description || quote.notes ? (
          <Text fontSize="xs" color="gray.600" noOfLines={2}>
            {quote.description || quote.notes}
          </Text>
        ) : null}

        <HStack spacing={2}>
          <Button size="xs" colorScheme="green" onClick={() => onAccept(quote, listingId)}>
            Accept this quote
          </Button>
        </HStack>
      </Stack>
    </Box>
  );
}

export default function AiQuoteCards({ result, onTriggerMessage }) {
  const quotes = result.quotes || [];
  const listingId = result.listingId;

  const handleAccept = (quote) => {
    if (!onTriggerMessage) return;
    onTriggerMessage('Accept this quote', {
      listingId,
      quoteId: quote.id || quote._id,
      entityId: listingId,
      entityType: 'listing',
    });
  };

  if (!quotes.length) {
    return (
      <Box borderWidth="1px" borderRadius="xl" p={3} bg="gray.50" borderColor="gray.200">
        <Text fontSize="sm" color="gray.500">No quotes available.</Text>
      </Box>
    );
  }

  return (
    <VStack align="stretch" spacing={2}>
      <HStack justify="space-between">
        <Text fontSize="10px" fontWeight="700" textTransform="uppercase" letterSpacing="0.15em" color="blue.500">
          {quotes.length} quote{quotes.length !== 1 ? 's' : ''} — cheapest first
        </Text>
        {result.summary?.cheapestQuoteId ? (
          <Badge colorScheme="green" borderRadius="full" px={2} fontSize="10px">Best price highlighted</Badge>
        ) : null}
      </HStack>
      {quotes.map((quote) => (
        <QuoteCard
          key={quote.id || quote._id}
          quote={quote}
          listingId={listingId}
          onAccept={handleAccept}
        />
      ))}
    </VStack>
  );
}
